import { render, staticRenderFns } from "./assignDialog.vue?vue&type=template&id=371000da&scoped=true"
import script from "./assignDialog.vue?vue&type=script&lang=js"
export * from "./assignDialog.vue?vue&type=script&lang=js"
import style0 from "./assignDialog.vue?vue&type=style&index=0&id=371000da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371000da",
  null
  
)

export default component.exports